export default __webpack_public_path__ + "static/media/SAS Alert Tone 16.a7f4a492.wav";